import { COUNTRY_OPTIONS } from './constants';

/*
  Teams store their country as a display name ("Japan", "England"), not a code. The create endpoint
  derives the plan's country and currency from that name itself, so this only exists to show the
  admin which currency the plan will be in. The aliases mirror the backend's country-name table.
*/
const ALIASES = {
  england: 'GBR',
  scotland: 'GBR',
  wales: 'GBR',
  'northern ireland': 'GBR',
  usa: 'USA',
  macedonia: 'MKD'
};

export function countryForTeamName(name) {
  const key = typeof name === 'string' ? name.trim().toLowerCase() : '';
  if (!key) return null;

  const code = ALIASES[key] || COUNTRY_OPTIONS.find((c) => c.name.toLowerCase() === key)?.code;
  return COUNTRY_OPTIONS.find((c) => c.code === code) || null;
}
